export const chargerDetailsInputDebounce = 300;
export const EDGE_DEMO_URL_FLAG = 'edgeDemo';
